import { render } from "./RemindyearCheck.vue?vue&type=template&id=18440e2f"
import script from "./RemindyearCheck.vue?vue&type=script&lang=js"
export * from "./RemindyearCheck.vue?vue&type=script&lang=js"

import "./RemindyearCheck.vue?vue&type=style&index=0&id=18440e2f&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__